import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaKey } from 'react-icons/fa';
import logoSGR from '../../assets/logo.svg';
import logoSwint from '../../assets/swintLogo.svg';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { Container, Content, ShowPasswords } from './styles';

interface ResetPasswordProps {
  password: string;
  password_confirmation: string;
}

const ResetPassoword: React.FC = () => {
  const { register, handleSubmit, setValue } = useForm();
  const [errorMessage, setErrorMessage] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [showPasswords, setShowPasswords] = useState(false);

  const onSubmit = useCallback(async (data: ResetPasswordProps) => {
    if (data.password !== data.password_confirmation) {
      setErrorMessage('As senhas informadas devem ser idênticas');
    } else {
      setErrorMessage('');
    }

    if (data.password === '' || data.password_confirmation === '') {
      setErrorMessage('Todos os campos devem ser preenchidos');
    } else {
      setErrorMessage('');
    }
  }, []);

  useEffect(() => {
    setValue('password', password);
    setValue('password_confirmation', passwordConfirmation);
  }, [setValue, password, passwordConfirmation]);

  return (
    <Container>
      <img src={logoSGR} alt="Logo SGRLoc" />
      <Content>
        <img src={logoSwint} alt="Logo Swint" />
        <h1>Alteração de Senha</h1>
        {errorMessage && <p>{errorMessage}</p>}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            {...register('password')}
            type={showPasswords ? 'text' : 'password'}
            placeholder="Digite uma senha"
            label="SENHA"
            onChange={e => setPassword(e.target.value)}
          />
          <Input
            {...register('password_confirmation')}
            type={showPasswords ? 'text' : 'password'}
            placeholder="Digite a mesma senha"
            label="CONFIRMAR SENHA"
            onChange={e => setPasswordConfirmation(e.target.value)}
          />
          <ShowPasswords>
            <input
              type="checkbox"
              id="pass"
              onChange={() => setShowPasswords(!showPasswords)}
            />
            <label htmlFor="pass">Mostrar senhas</label>
          </ShowPasswords>
          <Button type="submit" title="ALTERAR" icon={FaKey} />
        </form>
      </Content>
    </Container>
  );
};

export default ResetPassoword;
